import React, {Component} from 'react';

import 'sass/member/wallet/FooterWallet.scss';

import {t, dt} from 'l10n';

export default function FooterWallet(props) {
    return (
        <div></div>
    )
}


// WEBPACK FOOTER //
// ./src/components/wallet/FooterWallet.js